import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TertiaryButton } from '../../components/ui-toolkit/buttons.js';
import DeleteDraftModal from './delete-draft.modal.js';
import './edit-bar.scss';

const EditBar = ({
	isDraft, showDeleteDraftModal, toggleShowDeleteDraftModal, deleteDraft, editDraft,
}) => (
	<div className="edit-bar fixed-bottom">
		<div className="ino-container d-flex">
			{isDraft && (
				<div className="d-none d-md-block">
					<FormattedMessage id="edit_bar.preview_draft" />

					<DeleteDraftModal
						openModal={showDeleteDraftModal}
						deleteDraft={deleteDraft}
						keepDraft={toggleShowDeleteDraftModal}
					/>
				</div>
			)}

			<div className="text-center text-md-right flex-grow-1">
				{isDraft && (
					<TertiaryButton outline onClick={toggleShowDeleteDraftModal}>
						<FormattedMessage id="edit_bar.delete" />
					</TertiaryButton>
				)}

				<TertiaryButton onClick={editDraft}>
					{isDraft && <FormattedMessage id="edit_bar.edit_draft" /> }
					{!isDraft && <FormattedMessage id="edit_bar.edit" /> }
				</TertiaryButton>
			</div>
		</div>
	</div>
);

export default EditBar;
